// src/firebase.js
import firebase from 'firebase/app'
import 'firebase/messaging'
import configJson from '../config.json'

var envConfig = (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'test') ? process.env.NODE_ENV:'development';
var firebaseConfig = configJson[envConfig].firebase_config;

firebase.initializeApp(firebaseConfig)
const messaging = firebase.messaging()

export { messaging }
